import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_a_tree_select, {
          key: 0,
          "allow-clear": "",
          "show-search": "",
          "tree-node-filter-prop": "title",
          value: _ctx.selectedValue,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
          disabled: _ctx.disabled,
          multiple: _ctx.multiple,
          placeholder: _ctx.placeholder,
          dropdownStyle: { maxHeight: '200px', overflow: 'auto' },
          "tree-checkable": _ctx.multiple,
          "tree-data": _ctx.afterData(_ctx.data?.treeRecords),
          fieldNames: { label: 'name', key: 'id', value: 'id' },
          showCheckedStrategy: _ctx.SHOW_All,
          treeCheckStrictly: _ctx.treeCheckStrictly,
          onChange: _ctx.onChange,
          onClear: _ctx.onClear
        }, null, 8, ["value", "disabled", "multiple", "placeholder", "tree-checkable", "tree-data", "showCheckedStrategy", "treeCheckStrictly", "onChange", "onClear"]))
      : _createCommentVNode("", true)
  ]))
}